module.exports = __webpack_public_path__ + "static/media/bantex-logo-white.9aab7495.png";